/**
 * Insurance-specific configuration module for Offer creation.
 * Handles insurance unit type and classification dropdowns.
 */

import type { ConfigItem } from '../../lib/types';

export interface InsuranceConfig {
    unitTypeSelect: HTMLSelectElement | null;
    unitTypes: ConfigItem[];
}

/**
 * Populate insurance-specific dropdowns
 */
export function populateInsuranceDropdowns(config: InsuranceConfig) {
    const { unitTypeSelect, unitTypes } = config;

    if (unitTypeSelect) {
        unitTypeSelect.innerHTML = '<option value="">-- Select Type --</option>';
        unitTypes.forEach((item) => {
            const option = document.createElement('option');
            option.value = item.Id?.toString() || '';
            option.textContent = item.Name || item.Key;
            unitTypeSelect.appendChild(option);
        });
    }
}
